<template>
    <div class="search-user-container" v-if="callStatus !== 'connected'">
        <!-- <div class="search-section">
      <el-input class="inline-input" disabled v-model="searchInput" maxlength="11" placeholder="请输入用户ID"></el-input>
    </div> -->
        <div class="container_bottom">
            <div class="container_box">
                <div class="container_title">{{ (proType == 1 ? '购置补贴' : '应用补贴') }}远程视频核验</div>
                <div v-if="callStatus === 'calling' && isInviter" class="btn_box">
                    <div class="btn_hy">呼叫中，请稍候...</div>
                    <div :disabled="cancel" :loading="cancel" class="canly_btn" @click="handleCancelCallBtnClick">
                        取消
                    </div>
                </div>
                <!-- A30C336F-7C7B-4E04-A9FA-58D8F8386EB4 -->
                <div class="btn_hy" @click="handleCallBtnClick(searchInput)" v-else>
                    {{ $store.state.btnText }}
                </div>
                <!-- <div class="btn_hy" @click="loginout">
                    退出
                </div> -->
                <!-- <div class="btn_hy" @click="handleCallBtnClick2(searchInput)">
                    关闭
                </div> -->
            </div>
            <div class="img_right">
                <img height="100%" src="../../assets/shipinheyan.png" />
            </div>
            <!-- <audio class="audiols" src='@/assets/aishishuixian_hechangban.mp3' style="display: none;" loop></audio> -->

            <!-- <div class="img_dn">
        <img height="100%" src="../../assets/slt.png" />
      </div>
      <div class="home-page-section-list" v-show="callStatus !== 'connected'">
        <div
          v-if="callStatus === 'calling' && isInviter"
          class="calling-user-footer"
        >
          <el-button
            icon="el-icon-phone"
            type="warning"
            class="user-item-join-btn calling"
            >呼叫中请稍后...</el-button
          >
          <el-button
            type="danger"
            class="user-item-cancel-join-btn"
            :disabled="cancel"
            :loading="cancel"
            @click="handleCancelCallBtnClick"
            >取消</el-button
          >
        </div>
        <div class="home-page-section" @click="handleCallBtnClick(searchInput)">
          <img height="100" src="../../assets/spth.png" />
          <div class="home-page-section-title">视频通话</div>
        </div> -->
            <!-- <div class="home-page-section" @click="goto('/audio-call')">
          <img height="100" src="../../assets/yyth.png" />
          <div class="home-page-section-title">语音通话</div>
        </div> -->
            <!-- </div> -->
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { getSearchHistory } from "../../utils";
import { getApplymess, initiateVideo } from '@/api/index'

export default {
    name: "SearchUser",
    props: {
        callFlag: {
            type: Boolean,
        },
        cancelFlag: {
            type: Boolean,
        },
        textTitle: {
            type: String,
        }
    },
    data () {
        return {
            firstExecute: false,
            searchInput: "",
            callUserId: "",
            searchResultList: [],
            searchHistoryUser: getSearchHistory(),
            call: false,
            cancel: false,
            msg: "未获取到用户ID",
            applicationNoList: null,
            proType: "",
            objinfo: {}
        };
    },
    computed: {
        ...mapState({
            loginUserInfo: (state) => state.loginUserInfo,
            meetingUserIdList: (state) => state.meetingUserIdList,
            callStatus: (state) => state.callStatus,
            isAccepted: (state) => state.isAccepted,
            isInviter: (state) => state.isInviter,
            btnFlag:(state) => state.btnFlag
        }),
        userList: function () {
            if (this.searchInput === "" && this.searchHistoryUser.length !== 0) {
                return this.searchHistoryUser;
            }
            return this.searchResultList;
        },
    },
    watch: {
        callStatus: function (newStatus, oldStatus) {
            if (newStatus !== oldStatus && newStatus === "connected") {
                this.searchInput = "";
                this.searchResultList = [];
            }
            if (newStatus === "idle") {
                this.callUserId = "";
            }
        },
        callFlag (newVal) {
            this.call = newVal;
        },
        cancelFlag (newVal) {
            this.cancel = newVal;
        },
    },
    methods: {
        handleCallBtnClick: function (param) {
            if (this.btnFlag) {
                return false;
            }
            // this.$trtcCalling.logout()
            // music.pause();
            // let forwardMessage = tim.createForwardMessage({ //腾讯视频推送
            //     to: 'user1',
            //     conversationType: TIM.TYPES.CONV_C2C,
            //     // 消息优先级，用于群聊，如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息
            //     // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
            //     // priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
            //     payload: message, // 消息实例，已收到的或自己已发出的消息
            //     // 消息自定义数据（云端保存，会发送到对端，程序卸载重装后还能拉取到，v2.10.2起支持）
            //     // cloudCustomData: 'your cloud custom data'
            // });
            // let promise = tim.sendMessage(forwardMessage);
            // promise.then(function (imResponse) {
            //     // 发送成功
            //     console.log(imResponse);
            // }).catch(function (imError) {
            //     // 发送失败
            //     console.warn('sendMessage error:', imError);
            // });
            // return
            //推送短信
            initiateVideo({
                appUid: this.objinfo.appUId,
                areaCode: this.objinfo.areaCode,
                type: this.objinfo.t,
                deptName: this.objinfo.dw
            }).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: res.msg,
                        type: "success",
                    });
                    // 登录 trtcCalling
                    this.$store.commit("updataBtnFlag", true);
                    let promise = this.$trtcCalling.login({
                        userID: this.$store.state.loginUserInfo.userId,
                        userSig: this.$store.state.loginUserInfo.userSig,
                    })
                    promise.then((imResponse) => {
                        console.log(imResponse)
                    }).catch(error => {
                        this.$message({
                            message: error,
                            type: "error",
                        });
                    })
                    if (this.searchInput != "" && this.searchInput != null) {
                        this.$store.commit("updataBtnText", '呼叫中，请稍候...');
                        this.call = true;
                        this.callUserId = param;
                        this.$emit("callUser", { param });
                    } else {
                        this.$message({
                            message: this.msg,
                            type: "error",
                        });
                    }
                }
            })

        },
        handleCallBtnClick2 () {
            // this.callUserId = param;
            // this.$emit("callUser", { param });
            window.opener.postMessage(-1, '*')
            window.close(); ``
        },
        handleCancelCallBtnClick: function () {
            // 对方刚接受邀请，但进房未成功
            this.cancel = true;
            this.$store.commit("updataBtnFlag", false);
            this.$store.commit("updataBtnText", '点击核验');
            this.$store.commit("updataBtnFlag", false);
            this.$store.commit("updateCallStatus", "idle");
            this.$store.state.autioEle.pause();
            this.$trtcCalling.hangup();
            this.$emit("cancelCallUser");
        },
        GetRequest (localUrl) {
            //url例⼦：XXX.aspx?ID=" + ID + "&Name=" + Name；
            var url = localUrl; //获取url中"?"符以及其后的字串
            var addressParameter = {};
            if (url.indexOf("?") != -1) {
                //url中存在问号，也就说有参数。
                var str;
                if (url.indexOf("=") != -1) {
                    str = url.substr(1, url.indexOf("=") - 1);
                } else {
                    str = url.substr(1);
                }
                //地址栏参数解密
                var addressUrl = decodeURIComponent(atob(str));
                var addressData = addressUrl.split("&");
                for (var i = 0; i < addressData.length; i++) {
                    addressParameter[addressData[i].split("=")[0]] = unescape(
                        addressData[i].split("=")[1]
                    );
                }
            }
            return addressParameter;
        },
        getParams (name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.search.substr(1).match(reg); //search,查询？后面的参数，并匹配正则
            if (r != null) return unescape(r[2]);
            return null;
        }
    },
    created () {
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        let userId2;
        let applicationNo, userName, t, obj;

        if (window.location.search) {
            obj = this.GetRequest(window.location.search);
            applicationNo = obj.bh;
            t = obj.t
            userName = obj.dw
            this.proType = obj.t
        }
        let vm = this;
        vm.$store.commit("setsubsidiesparam", {
            applicationNo,
            userName
        });

        getApplymess({
            applicationNo,
            areaCode: applicationNo.substring(0, 2),
            type: t
        }).then(res => {
            vm.searchInput = res.appUId;
            userId2 = res.appUId;

            this.objinfo = Object.assign(obj, res)
            vm.applicationNoList = res;
            console.log(res,1111111)
            vm.applicationNoList['factoryNumber'] = vm.applicationNoList.factoryNumber.split(",")
            this.$emit("applicationInfo", {
                userId2,
                applicationNo,
                applyId: res.applyId,
                userName,
                applicationNoList: vm.applicationNoList,
                t
            })
            loading.close();
        }).catch(err => {
            loading.close();
        })
    },
};
</script>

<style scoped>
.home-page-section-title {
    font-size: 34px;
    font-weight: bold;
}

.container_box {
    height: 250px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.home-page-section-list {
    height: 470px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.container_title {
    font-size: 36px;
    letter-spacing: 10px;
    color: #fff;
}

.btn_hy {
    width: 60%;
    height: 60px;
    /* border-radius: 30px; */
    line-height: 60px;
    color: #fff;
    font-weight: bold;
    font-size: 24px;
    box-shadow: 4px 5px 8px rgb(5, 73, 200);
    background-image: linear-gradient(#ffd359, #ffa549);
    cursor: pointer;
}

.canly_btn {
    background: #df363e;
    width: 30%;
    height: 60px;
    line-height: 60px;
    color: #fff;
    font-weight: bold;
    font-size: 24px;
    box-shadow: 4px 5px 8px rgb(5, 73, 200);
    cursor: pointer;
}

.btn_box {
    display: flex;
    justify-content: space-between;
}

.img_right {
    height: 550px;
    padding-top: 50px;
}

/* .home-page-container {
  height: 100%;
  overflow: hidden;
  background: url("../../assets/beijing.png") no-repeat;
  background-size: 100% 100%;
} */
.home-page-header {
    padding: 30px 0 10px;
    font-size: 24px;
}

.home-page-section {
    border-radius: 6px;
    color: #ffffff;
    width: 400px;
    height: 200px;
    margin: 0px auto;
    display: flex;
    /* align-items: center; */
    justify-content: space-around;
    border: 1px solid #ffffff;
    background: rgba(255, 255, 255, 0.2);
    cursor: pointer;
}

.home-page-section:hover {
    cursor: pointer;
}

.change-name {
    margin-left: 10px;
    text-decoration: underline;
    color: #5f6368;
    font-size: 16px;
    cursor: pointer;
}

.container_bottom {
    width: 1400px;
    margin: 0 auto;
    display: flex;
    height: 100%;
    justify-content: space-around;
    align-items: center;
    padding-top: 5%;
}

@media screen and (max-width: 1400px) {
    .container_bottom {
        width: 1200px !important;
    }

    .img_right {
        height: 450px;
    }
}


.user-item-join-btn {
    font-size: 34px;
}

.content_box {
    width: 45%;
    padding: 50px;
    background: #fff;
    margin: 80px auto 0;
}

.content_box_title {
    font-size: 36px;
    color: #0295fa;
    font-weight: bold;
    /* padding: 20px 0; */
    margin: 10px 0 80px;
}

.search-user-container {
    /* width: 400px; */
    margin: 0 auto;
}

.search-section {
    display: flex;
    flex-direction: row;
}

.search-user-btn {
    margin-left: 10px;
}

.search-user-list {
    padding: 80px 0 0px;
}

.search-user-list-title {
    margin-top: 20px;
    font-size: 18px;
    text-align: left;
}

.user-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
}

.user-item-info {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.user-item-avatar-wrapper img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
}

.user-item-username {
    margin-left: 20px;
}

@media screen and (max-width: 1660px) {
    .content_box {
        width: 55%;
    }
}

@media screen and (max-width: 1280px) {
    .content_box {
        width: 60%;
    }
}

@media screen and (max-width: 767px) {
    .search-user-container {
        width: 90%;
    }

    .content_box {
        width: 80%;
    }

    .biaos {
        height: 80px;
    }
}
</style>
